// Action to set user roles
export const setUserRoles = (roles) => {
    return {
      type: 'SET_USER_ROLES',
      payload: roles,
    };
  };
  
  // Action to set loading state
  export const setLoading = (loading) => {
    return {
      type: 'SET_LOADING',
      payload: loading,
    };
  };
  
  